export enum CancellationPoliciesStatus {
  Free = 'FREE',
  Partial = 'PARTIAL',
  NoRefund = 'NO_REFUND',
}
